import { hydrateStreamingForTenant, tenantSlugOf } from './streamingSlice';

// Runs side effects when the selected tenant changes (`user/selectTenant`):
//  - resets the RTK Query cache so no previous-tenant responses are served
//  - re-hydrates the streaming slice from the new tenant's localStorage keys
//    (the slice itself is cleared synchronously by its extraReducers).
// Lives in middleware rather than Profile.selectTenantAndSetData so every
// selectTenant dispatch is covered, and so Profile needn't import the RTK API
// (which would create a Constants ↔ store import cycle in Profile's tests).
//
// TODO(follow-up): medchartApi's baseUrl is still the central API URL; move it
// to the per-tenant base so the cache is naturally keyed by tenant.
export function createTenantSwitchMiddleware(api) {
  return (store) => (next) => (action) => {
    if (action?.type !== 'user/selectTenant') return next(action);

    const prevSlug = tenantSlugOf(store.getState().user?.selectedTenant);
    const result = next(action);
    const nextSlug = tenantSlugOf(action.payload);

    if (prevSlug !== nextSlug) {
      store.dispatch(api.util.resetApiState());
      store.dispatch(hydrateStreamingForTenant(nextSlug));
    }
    return result;
  };
}
